import React, { useState, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { debounce } from 'debounce';
import ChevronUpIcon from '@moda/icons/chevron-up-12';
import { Clickable } from '@moda/om';
import './BackToTop.scss';

const MAX_SCROLLED = 1110;
const DEBOUNCE_AMOUNT_MS = 100;

export const BackToTop: React.FC = () => {
  const shouldShowButton = useCallback(() => {
    return (window.scrollY || window.pageYOffset) >= MAX_SCROLLED;
  }, []);

  const [showButton, setShow] = useState(false);

  const handleScroll = useCallback(() => {
    if (shouldShowButton()) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [shouldShowButton]);

  const debounceScroll = useMemo(() => debounce(handleScroll, DEBOUNCE_AMOUNT_MS), [handleScroll]);

  useEffect(() => {
    window.addEventListener('scroll', debounceScroll);
    return () => window.removeEventListener('scroll', debounceScroll);
  }, [showButton, setShow, debounceScroll]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Clickable
      className={classNames('BackToTop', {
        'BackToTop--showing': showButton,
        'BackToTop--hiding': !showButton
      })}
      tabIndex={0}
      role="button"
      onClick={scrollToTop}
    >
      <ChevronUpIcon className="BackToTop__icon" />
      <div className="BackToTop__text">TOP</div>
    </Clickable>
  );
};
